import React, { Component } from "react";
import FormSummary from "@components/FormSummary";
import { Button, Table, Modal, message } from "antd";
import {
    getAccoutListData,
    createSumit,
    editSumit,
    getRoles,
    deleteData
} from "@api/user";
import bus from "@utils/bus";
import { store } from "../store-manager";
import searchSelect from "./SearchSelect";
import searchInput from './SearchInput';
import { getChannelByLvl } from "@api/user";
import { getAllGames } from "@api/statistics";

const confirm = Modal.confirm;
let currentId = "";

export default class UserManage extends Component {
    formRef = React.createRef();

    state = {
        formItems: [
            {
                key: "name",
                label: "用户名",
                require: true,
                componentName: "input",
                message: "请填写用户名"
            },
            {
                key: "roles",
                label: "角色",
                require: true,
                componentName: "select",
                message: "请填写角色",
                options: [],
                onChange: this.handleRolesChange.bind(this)
            },
            {
                key: "mobile",
                label: "手机号",
                require: true,
                componentName: "input",
                message: "请填写手机号"
            },
            {
                key: "games",
                label: "可查看的游戏",
                require: true,
                componentName: "select",
                message: "请选择可查看游戏",
                options: [],
                mode: "multiple",
                onChange: this.handleSelectGames.bind(this)
            }
        ],
        visible: false,
        operateType: "",
        formDefaultValue: {},
        tableData: [],
        pagination: {
            pageSzie: 10,
            current: 1,
            total: 0
        },
        allChannel: [],
        channels: [],
        roles: [],
        currentRole: "",
        allSelect: [
            {
                type: 'search-select',
                key: "role",
                placeholder: "请选角色",
                defaultValue: "",
                options: [{ value: "", label: "全部" }],
                title: "角色"
            },
            {
                type: 'search-select',
                key: "firstLevelChannelId",
                // mode: "multiple",
                placeholder: "请选一级渠道",
                defaultValue: "",
                options: [{ value: "", label: "全部" }],
                title: "渠道"
            },
            {
                type: 'search-input',
                key: 'name',
                placeholder: '请输入用户名',
                defaultValue: '',
                title: '用户名'
            },
            {
                type: 'search-input',
                key: 'mobile',
                placeholder: '请输入手机号',
                defaultValue: '',
                title: '手机号'
            }
        ],
        selectedVal: { firstLevelChannelId: '', role: '', mobile: '', name: '' }
    };

    async handleSelectGames(ids) {
        if (ids.includes('*')) {
            await Promise.resolve()
            this
                .formRef
                .current
                .setFieldsValue({ games: ['*'] });
        }
    }

    getSelectGames = async () => {
        try {
            const { data } = await getAllGames();
            if (data.meta.errCode === 0) {
                const options = data
                    .data
                    .map(game => ({ value: game.gameId, label: game.gameName }));

                this
                    .state
                    .formItems
                    .forEach(formItem => {
                        if (formItem.key === 'games') {
                            formItem.options = [
                                { value: '*', label: '全部游戏' },
                                ...options
                            ];

                        }
                    });

                this.setState({ gameOptions: options });
            }
        } catch (error) { }
    }

    handleSelectChange = (value, key) => {
        const { selectedVal } = this.state;

        selectedVal[key] = value;
        this.setState({ selectedVal });
    };

    handleInputChange = (value, key) => {
        const { selectedVal } = this.state;

        selectedVal[key] = value;
        this.setState({ selectedVal });
    }

    handleSearch = () => {
        this.getAccoutListData({ page: 1, size: 10 });
    };

    handleRolesChange(val) {
        // 处理角色和渠道的联动关系
        this.handleRolesToChannel(val);
        bus.dispatch("form_summary", { firstLevel: [] });
    }

    handleRolesToChannel = val => {
        let tempFormItems = this.state.formItems.slice(0, 4);
        let tempArr = [];
        let allChannel = this.state.allChannel;
        let firstLevel = {
            key: "firstLevel",
            label: "一级渠道",
            require: true,
            componentName: "select",
            message: "请填一级渠道",
            options: [...allChannel],
            allowClear: true,
        };

        const rolesName = this.state.roles[val];

        if (rolesName === "渠道管理员") {
            Object.assign(firstLevel, {
                mode: "multiple",
                options: [{ value: "*", label: "全部一级渠道" }, ...allChannel]
            });
        }

        tempArr = [firstLevel];

        if (rolesName === "超级管理员" || rolesName === "平台财务人员") {
            // 平台财务人员
            tempArr = [];
        }

        if (rolesName === "二级渠道用户" || rolesName === "三级渠道用户" || rolesName === "三级渠道用户无渠道账单") {
            firstLevel.onChange = this.handleOnChange.bind(this);
        }

        this.setState({
            formItems: tempFormItems.concat(tempArr),
            currentRole: rolesName
        });

        return tempArr;
    };

    handleOnChange(val) {
        console.log(val);
        let tempFormItems = this.state.formItems;
        if (val === "*") {
            this.setState({
                formItems: tempFormItems.filter(item => {
                    return item.key !== "secondLevel";
                })
            });
            return;
        }

        this.setSecondChannel(val);
        bus.dispatch("form_summary", { secondLevel: [] });
    }

    /**
     * 
     * @param {*} data 对应的二级渠道 
     */
    handleSecondChannelChange(data) {
        return async val => {
            await this.getThirdChannelById(val)
            const tempsub = store.remote.thirdChannel || []
            let tempOptions = tempsub.map(el => ({
                value: el.id,
                label: el.name
            }));
            let tempData = this.state.formItems.slice(0, 6);

            bus.dispatch("form_summary", { thirdLevel: [] });

            tempData.push({
                key: "thirdLevel",
                label: "三级渠道",
                require: true,
                componentName: "select",
                message: "请填三级渠道",
                options: [
                    { value: "*", label: "全部三级渠道" },
                    ...tempOptions
                ],
                allowClear: true,
                mode: "multiple"
            });
            this.setState({ formItems: tempData });
        };
    }
    /**
     * @func 根据
     * @param {String} val 
     */
    setSecondChannel = async val => {
        const isThirdRole = this.state.currentRole === "三级渠道用户" || this.state.currentRole === "三级渠道用户无渠道账单";
        await this.getSecondChanelById(val)
        const secondChannel = store.remote.secondChannel
        const subs = secondChannel || [];
        let initOpt = isThirdRole
            ? []
            : [{ value: "*", label: "全部二级渠道" }];
        let tempData = this.state.formItems.slice(0, 5);
        console.log(tempData);

        initOpt = initOpt.concat(
            subs.map(item => ({ value: item.id, label: item.name }))
        );

        let tempSecondChannel = {
            key: "secondLevel",
            label: "二级渠道",
            require: true,
            componentName: "select",
            message: "请填二级渠道",
            options: initOpt,
            allowClear: true,
            mode: isThirdRole ? "" : "multiple",
        };
        if (isThirdRole) {
            tempSecondChannel.onChange = this.handleSecondChannelChange(subs).bind(this);
            // tempSecondChannel.onChange = this.setThirdChannel().bind(this)
        }

        tempData.push(tempSecondChannel);
        this.setState({ formItems: tempData });
    };

    setThirdChannel = async val => {
        console.log();
    }

    handleOk = async (e) => {
        let form = this.formRef.current;

        try {
            const values = await form.validateFields();
            console.log(values);

            values.games = this.checkSelectGames(values.games);

            if (this.state.operateType === "create") {
                this.handleCreate(values);
            } else if (this.state.operateType === "edit") {
                this.handleEdit(values);
            }
        } catch (err) {
            console.log(err);
        }
    };

    handleCancle = () => {
        const tempFormItems = this.state.formItems;

        this.setState({ formItems: tempFormItems.slice(0, 4), visible: false });
    };

    checkSelectGames = (gameIds) => {
        if (gameIds.includes('*')) {
            return this.state.gameOptions.map(option => option.value);
        }
        return gameIds;
    }

    handleCreate = data => {
        const params = this.handleParams(data);

        createSumit(params).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }
            message.success("创建用户成功");
            this.setState({ visible: false });
            this.getAccoutListData({ page: 1, size: 10 });
        });
    };

    handleParams = data => {
        let tempData = JSON.parse(JSON.stringify(data));

        let params = {
            name: tempData.name,
            mobile: tempData.mobile,
            roles: [tempData.roles],
            games: tempData.games
        };

        if (tempData.firstLevel) {
            if (Array.isArray(tempData.firstLevel)) {
                params.firstLevelChannelIds = tempData.firstLevel.includes("*")
                    ? ["*"]
                    : tempData.firstLevel;
            } else {
                params.firstLevelChannelIds = [tempData.firstLevel];
            }
        }

        if (tempData.secondLevel) {
            if (Array.isArray(tempData.secondLevel)) {
                params.secondLevelChannelIds = tempData.secondLevel.includes(
                    "*"
                )
                    ? ["*"]
                    : tempData.secondLevel;
            } else {
                params.secondLevelChannelIds = [tempData.secondLevel];
            }
        }

        if (tempData.thirdLevel) {
            params.thirdLevelChannelIds = tempData.secondLevel.includes("*")
                ? ["*"]
                : tempData.thirdLevel;
        }

        return params;
    };

    handleEdit = data => {
        const params = Object.assign(this.handleParams(data), {
            id: currentId
        });

        editSumit(params).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }
            message.success("编辑成功");
            this.setState({ visible: false });
            this.getAccoutListData({
                page: this.state.pagination.current,
                size: 10
            });
        });
    };

    beforeEdit = async data => {
        // 如果是一级渠道角色 仅仅请求一级渠道数据
        // 如果是二级渠道角色 先请求一级渠道数据 再请求对应二级渠道数据
        // 如果是三级渠道角色 先请求一级渠道数据 再请求二级渠道数据 最后请求对应三级渠道数据
        await this.getFirstChannel()
        currentId = data.id;
        console.log(data);

        let tempChannel = this.handleRolesToChannel(data.roles[0]);
        const rolesName = this.state.roles[data.roles[0]];
        let tempdata = {
            name: data.name,
            roles: data.roles[0],
            mobile: data.mobile,
            games: ['*'] // TODO
        };

        if (data.firstLevelChannelIds && data.firstLevelChannelIds.length > 0) {
            if (rolesName === "渠道管理员") {
                tempdata.firstLevel = data.firstLevelChannelIds.includes("*")
                    ? ["*"]
                    : data.firstLevelChannelIds;
            } else {
                tempdata.firstLevel = data.firstLevelChannelIds[0];
            }
        }


        if (
            data.secondLevelChannelIds &&
            data.secondLevelChannelIds.length > 0
        ) {
            // 
            await this.getSecondChanelById(tempdata.firstLevel)
            // let tempsecond =
            //     this.state.channels.find(
            //         item => item.id === tempdata.firstLevel
            //     ).sub || [];
            let tempsecond = store.remote.secondChannel
            let option = tempsecond.map(item => ({
                value: item.id,
                label: item.name
            }));

            let tempSecondChannel = {
                key: "secondLevel",
                label: "二级渠道",
                require: true,
                componentName: "select",
                message: "请填二级渠道",
                options: [{ label: "全部二级渠道", value: "*" }, ...option],
                allowClear: true,
                mode: "multiple"
            };

            tempChannel.push(tempSecondChannel);

            if (rolesName === "二级渠道用户") {
                tempdata.secondLevel = data.secondLevelChannelIds.includes("*")
                    ? ["*"]
                    : data.secondLevelChannelIds;
            } else {
                tempdata.secondLevel = data.secondLevelChannelIds[0];
            }
        }

        if (data.thirdLevelChannelIds && data.thirdLevelChannelIds.length > 0) {
            tempChannel[1].options.shift();
            tempChannel[1].mode = "";
            await this.getSecondChanelById(tempdata.firstLevel)
            await this.getThirdChannelById(tempdata.secondLevel)
            let tempsecond = store.remote.secondChannel
            // let tempsecond =
            //     this.state.channels.find(
            //         item => item.id === tempdata.firstLevel
            //     ).sub || [];

            // let tempthird =
            //     tempsecond.find(item => item.id === tempdata.secondLevel).sub ||
            //     [];
            let tempthird = store.remote.thirdChannel
            let option = tempthird.map(item => ({
                value: item.id,
                label: item.name
            }));

            tempChannel[1].onChange = this.handleSecondChannelChange(
                tempsecond
            ).bind(this);

            tempChannel.push({
                key: "thirdLevel",
                label: "三级渠道",
                require: true,
                componentName: "select",
                message: "请填三级渠道",
                options: [{ label: "全部三级渠道", value: "*" }, ...option],
                allowClear: true,
                mode: "multiple"
            });
            console.log(tempChannel);
            tempdata.thirdLevel = data.thirdLevelChannelIds;
        }

        this.setState({
            formItems: this.state.formItems.slice(0, 4).concat(tempChannel),
            visible: true,
            operateType: "edit",
            formDefaultValue: tempdata
        });
    };

    beforeDelete = data => {
        confirm({
            title: "您确定删除此条数据吗",
            // content: 'Some descriptions',
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk: () => {
                console.log("OK");
                this.delete(data);
            },
            onCancel: () => {
                console.log("Cancel");
            }
        });
    };

    delete = data => {
        deleteData({ id: data.id }).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }
            message.success("删除成功");
            this.getAccoutListData({
                page: this.state.pagination.current,
                size: 10
            });
        });
    };

    getAccoutListData = data => {
        const { selectedVal } = this.state;
        const params = { ...data, ...selectedVal };

        getAccoutListData(params).then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            const paging = res.data.meta.paging || {};
            this.setState({
                pagination: {
                    current: paging.page,
                    pageSize: paging.size,
                    total: paging.total
                },
                tableData: res.data.data.list || []
            });
        });
    };

    getFirstChannel = async () => {
        const ret = await getChannelByLvl(1)
        if (ret && ret.data && ret.data.data) {
            const resp = ret.data.data || []
            store.sync({
                firstChannel: resp
            })
            console.log('all first channel: ', resp);
        }
    }

    getSecondChanelById = async (parentId) => {
        const ret = await getChannelByLvl(2, parentId)
        if (ret && ret.data && ret.data.data) {
            const resp = ret.data.data || []
            console.log('all second channel: ', resp);
            store.sync({
                secondChannel: resp
            })
        }
    }

    getThirdChannelById = async (parentId) => {
        const ret = await getChannelByLvl(3, parentId)
        if (ret && ret.data && ret.data.data) {
            const resp = ret.data.data || []
            console.log('all third channel: ', resp);
            store.sync({
                thirdChannel: resp
            })
        }
    }

    getAllChannel = async () => {
        if (true) {
            await this.getFirstChannel()
            const firstChannel = store.remote.firstChannel
            let initOpt = [{ value: "*", label: "全部一级渠道" }];
            const data = firstChannel || [];
            // 一级渠道用户, 一级渠道不显示全部 '一级渠道'
            if (bus.userInfo.roleTp === 4) {
                initOpt = [];
            }
            const tempAllChannel = firstChannel.map(item => ({ value: item.id, label: item.name }));
            const { allSelect } = this.state;
            this.setState({
                allChannel: tempAllChannel,
                channels: [],
                allSelect
            });
            this.setFormData(this.state.formItems, "firstLevel", data, initOpt);
        } else {

            await store.hasAllChannel()
            const res = store.remote.channel

            const data = res || [];
            let initOpt = [{ value: "*", label: "全部一级渠道" }];

            // 一级渠道用户, 一级渠道不显示全部 '一级渠道'
            if (bus.userInfo.roleTp === 4) {
                initOpt = [];
            }

            const tempAllChannel = data.map(item => ({ value: item.id, label: item.name }));
            const { allSelect } = this.state;

            allSelect[1].options = [{ value: '', label: '全部' }].concat(tempAllChannel);

            this.setState({
                allChannel: tempAllChannel,
                channels: data,
                allSelect
            });
            this.setFormData(this.state.formItems, "firstLevel", data, initOpt);
        }


    };

    getRoles = () => {
        getRoles().then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }

            const tempRoles = res.data.data.roles || [];
            const josnRoles = {};
            let roleOptions = [];
            const { allSelect } = this.state;

            tempRoles.forEach(item => {
                roleOptions.push({ label: item.name, value: item.id });
                josnRoles[item.id] = item.name;
            });

            allSelect[0].options = [{ label: '全部', value: '' }].concat(roleOptions);

            this.setState({ roles: josnRoles, allSelect });
            bus._roles = josnRoles;
            const initOpt = [];
            this.setFormData(
                this.state.formItems,
                "roles",
                res.data.data.roles,
                initOpt
            );
        });
    };

    setFormData = (data, key, options, initOpt) => {
        const tempOptions = options || [];
        const tempData = data;

        tempData.forEach(item => {
            if (item.key === key) {
                item.options = initOpt.slice();
                item.options = item.options.concat(
                    tempOptions.map(item => {
                        return { value: item.id, label: item.name };
                    })
                );
            }
        });

        this.setState({ formItems: tempData });
    };

    changePage = page => {
        const params = {
            page: page.current,
            size: 10
        };
        this.getAccoutListData(params);
    };

    componentDidMount() {
        this.getAccoutListData({ page: 1, size: 10 });
        this.getRoles();
        this.getAllChannel();
        this.getSelectGames();
    }

    render() {
        const columns = [
            {
                title: "用户名",
                dataIndex: "name",
                align: "center"
            },
            {
                title: "手机号",
                dataIndex: "mobile",
                align: "center"
            },
            {
                title: "角色",
                dataIndex: "roles",
                align: "center",
                render: item => {
                    return <span>{this.state.roles[item[0]] || "---"}</span>;
                }
            },
            {
                title: "一级渠道",
                key: "firstLevel",
                dataIndex: "firstLevelChannelNames",
                align: "center",
                width: "200px",
                render: firstLevelChannelNames => (
                    <span>
                        {firstLevelChannelNames &&
                            (firstLevelChannelNames.includes("*")
                                ? "全部"
                                : firstLevelChannelNames.join(", "))}
                    </span>
                )
            },
            {
                title: "二级渠道",
                key: "secondLevel",
                dataIndex: "secondLevelChannelNames",
                align: "center",
                width: "200px",
                render: secondLevelChannelNames => (
                    <span>
                        {secondLevelChannelNames &&
                            (secondLevelChannelNames.includes("*")
                                ? "全部"
                                : secondLevelChannelNames.join(", "))}
                    </span>
                )
            },
            {
                title: "三级渠道",
                key: "thirdLevel",
                dataIndex: "thirdLevelChannelNames",
                align: "center",
                width: "200px",
                render: thirdLevelChannelNames => (
                    <span>
                        {thirdLevelChannelNames &&
                            (thirdLevelChannelNames.includes("*")
                                ? "全部"
                                : thirdLevelChannelNames.join(", "))}
                    </span>
                )
            },
            {
                title: "操作",
                align: "center",
                dataIndex: "key",
                width: "200px",
                render: (text, record, index) => (
                    <div>
                        <Button
                            key="edit"
                            type="primary"
                            onClick={() => {
                                this.beforeEdit(record);
                            }}
                        >
                            编辑
                        </Button>
                        <Button
                            key="delete"
                            type="danger"
                            onClick={() => {
                                this.beforeDelete(record);
                            }}
                            style={{ marginLeft: 8 }}
                        >
                            删除
                        </Button>
                    </div>
                )
            }
        ];

        return (
            <div>
                <h2 style={{ marginTop: 8 }}>用户管理</h2>
                <ul style={{ overflow: "hidden", marginTop: 28 }}>
                    {this
                        .state
                        .allSelect
                        .map(item => {
                            let view = null;
                            switch (item.type) {
                                case 'search-select':
                                    view = searchSelect.call(this, item);
                                    break;
                                case 'search-input':
                                    view = searchInput.call(this, item);
                                    break;
                                default:
                                    view = null;
                            }
                            return (
                                <li
                                    key={item.key}
                                    style={{
                                        float: "left",
                                        width: 200,
                                        marginRight: 20
                                    }}
                                >
                                    <span style={{ lineHeight: "32px" }}>
                                        {item.title}
                                    </span>
                                    {view}
                                </li>
                            );
                        })}
                    <li
                        style={{
                            float: "left",
                            marginRight: 20
                        }}
                    >
                        <Button type="primary" onClick={this.handleSearch}>
                            查询
                        </Button>
                    </li>
                    <li
                        style={{
                            float: "right",
                            marginRight: 20
                        }}
                    >
                        <Button
                            type="primary"
                            onClick={() => {
                                this.setState({
                                    visible: true,
                                    operateType: "create",
                                    formDefaultValue: {}
                                });
                            }}
                        >
                            用户创建
                        </Button>
                    </li>
                </ul>
                <Table
                    locale={{ emptyText: "暂无数据" }}
                    rowKey={item => item.id}
                    style={{ marginTop: 18 }}
                    columns={columns}
                    pagination={this.state.pagination}
                    onChange={(page, pageSize) => {
                        this.changePage(page);
                    }}
                    dataSource={this.state.tableData}
                />
                <Modal
                    destroyOnClose={true}
                    title="创建"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancle}
                    okText="确认"
                    cancelText="取消"
                >
                    <FormSummary
                        ref={this.formRef}
                        formItems={this.state.formItems}
                        operateType={this.state.operateType}
                        formDefaultValue={this.state.formDefaultValue}
                    />
                </Modal>
            </div>
        );
    }
}
